export var normal_frag_params = "\nvarying vec3 vNormal;\n";
//# sourceMappingURL=normal-frag-params.glsl.js.map